import { Routes } from '@angular/router';
import { AuthGuard } from './modules/shared/auth.guard';
import { noAuthGuard } from './modules/shared/no-auth.guard';

export const routes: Routes = [
    {
        path:'', canActivate: [noAuthGuard],
        loadComponent: () => import('./modules/components/wallet-connection/wallet-connection.component').then(m => m.WalletConnectionComponent)
    },
    {
        path:'locker', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/locker-management/locker-management.component').then(m => m.LockerManagementComponent)
    },
    {
        path:'locker/create', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/locker-actions/locker-actions.component').then(m => m.LockerActionsComponent)
    },
    {
        path:'announcement', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/announcement/announcement.component').then(m => m.AnnouncementComponent)
    },
    {
        path:'announcement/create', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/announcement-actions/announcement-actions.component').then(m => m.AnnouncementActionsComponent)
    },
    {
        path:'announcement/edit/:id' ,canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/announcement-actions/announcement-actions.component').then(m => m.AnnouncementActionsComponent)
    },
    {
        path:'app-management', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/app-management/app-management.component').then(m => m.AppManagementComponent)
    },
    {
        path:'app-management/create', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/app-management-actions/app-management-actions.component').then(m => m.AppManagementActionsComponent)
    },
    {
        path:'app-management/edit/:id', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/app-management-actions/app-management-actions.component').then(m => m.AppManagementActionsComponent)
    },
    {
        path:'app-message', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/mobile-app-announcement/mobile-app-announcement.component').then(m => m.MobileAppAnnouncementComponent)
    },
    {
        path:'app-message/create', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/mobile-app-announcement-action/mobile-app-announcement-action.component').then(m => m.MobileAppAnnouncementActionComponent)
    },
    {
        path:'app-message/edit/:id', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/mobile-app-announcement-action/mobile-app-announcement-action.component').then(m => m.MobileAppAnnouncementActionComponent)
    },
    {
        path:'claim-management', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/claim-management/claim-management.component').then(m => m.ClaimManagementComponent)
    },
    {
        path:'app-announcement', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/mobile-app-live-banner-management/mobile-app-live-banner-management.component').then(m => m.MobileAppLiveBannerManagementComponent),

    },
    {
        path:'app-announcement/create', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/mobile-app-live-banner-actions/mobile-app-live-banner-actions.component').then(m => m.MobileAppLiveBannerActionsComponent)
    },
    {
        path:'app-announcement/edit/:id', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/mobile-app-live-banner-actions/mobile-app-live-banner-actions.component').then(m => m.MobileAppLiveBannerActionsComponent)
    },
    {
        path:'app-notification', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/notification-management/notification-management.component').then(m => m.NotificationManagementComponent)
    },
    {
        path:'app-notification/create', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/notification-management-actions/notification-management-actions.component').then(m => m.NotificationManagementActionsComponent)
    },
    {
        path:'visitor-management', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/visitor-management/visitor-management.component').then(m => m.VisitorManagementComponent)
    },
    {
        path:'banner-management',
        children: [
            {
                path: '',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/banner-management/banner-management.component').then(m => m.BannerManagementComponent)
            },
            {
                path: 'create',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/banner-management-actions/banner-management-actions.component').then(m => m.BannerManagementActionsComponent)
            },
            {
                path: 'edit/:id',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/banner-management-actions/banner-management-actions.component').then(m => m.BannerManagementActionsComponent)
            }
        ]
    },
    {
        path:'audio-announcement',
        children: [
            {
                path: '',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/audio-announcement/audio-announcement.component').then(m => m.AudioAnnouncementComponent)
            },
            {
                path: 'create',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/audio-announcement-actions/audio-announcement-actions.component').then(m => m.AudioAnnouncementActionsComponent)
            },
            {
                path: 'edit/:id',
                canActivate: [AuthGuard],
                loadComponent: () => import('./modules/components/audio-announcement-actions/audio-announcement-actions.component').then(m => m.AudioAnnouncementActionsComponent)
            }
        ]
    },
    {
        path:'reports', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/reports/reports.component').then(m => m.ReportsComponent)
    },
    {
        path:'newsletter-management', canActivate: [AuthGuard],
        loadComponent: () => import('./modules/components/newsletter-management/newsletter-management.component').then(m => m.NewsletterManagementComponent)
    }

];
